import dayjs from 'dayjs'

const getGameDateTime = (startDate: number) => {
  const dateTime = dayjs(startDate)

  let date = dateTime.format('DD MMM')
  // We'll return the raw timestamp so it can be formatted by TimeValue component
  const time = startDate

  if (dateTime.isSame(dayjs(), 'day')) {
    date = 'Today'
  } else if (dateTime.isSame(dayjs().add(1, 'day'), 'day')) {
    date = 'Tomorrow'
  }

  return { date, time }
}

export default getGameDateTime
